
import { useState, useEffect, useRef} from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";
import emotion from "../emotion.png";
//import InputRadioButton from "../helpers/InputRadioButton";

function InputTextAreaRadio(props)
{

    
    const inputRef = useRef( null );
    
    
    const [val, setVal] = useState(props.value);
    const [checked, setChecked] = useState(props.checked);
    const [req, setRequired] = useState(props.req);
    const [firstUp, setFirstUp] = useState(props.firstUp);
    const [cn, setClassName] = useState('');
    
    const [onShow,setOnShow] = useState(false);

    const [emo, setEmo] = useState('hide'); //show

   

    const checkAndChange = (e) =>
    {
        var v = e.target.value;



        if(firstUp != undefined && firstUp == '1')
        {
            v =  v.charAt(0).toUpperCase() + v.slice(1);
        }


        if(v != undefined) setVal(v);

        var correct = true;

        if(req == '1' && v.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    const changeEmo = () =>
    {
            if(emo == 'hide') {
                setEmo('show');
            }else setEmo('hide');

            inputRef.current.focus();
    
            
    }

    const selectEmo = (e) => {

        var em = e.target.getAttribute('em');      
        var vx = e.target.getAttribute('v');      

        if(vx ==null) vx = '';

        var v = vx + "" + em;
        
 
 

        setVal(v );
        setEmo('hide');

        var correct = true;

        if(req == '1' && v.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }  
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }


 
 


    useEffect(() => {

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {      
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })


    var emobxo =  <span className="emo_box shadowx ">
                         <span className="emoimg" em="😀" v={val} onClick={selectEmo}>😀</span>
                         <span className="emoimg" em="😁" v={val}  onClick={selectEmo}>😁</span>
                         <span className="emoimg" em="😆" v={val}  onClick={selectEmo}>😆</span>
                         <span className="emoimg" em="😅"  v={val} onClick={selectEmo}>😅</span>
                         <span className="emoimg" em="🤣"  v={val} onClick={selectEmo}>🤣</span>
                         <span className="emoimg" em="🥲"  v={val} onClick={selectEmo}>🥲</span>
                         <span className="emoimg" em="☺️"  v={val} onClick={selectEmo}>☺️</span>
                         <span className="emoimg" em="😇"  v={val} onClick={selectEmo}>😇</span>
                         <span className="emoimg" em="🙁"  v={val} onClick={selectEmo}>🙁</span>
                         <span className="emoimg" em="😖"  v={val} onClick={selectEmo}>😖</span>
                         <span className="emoimg" em="🤔"  v={val} onClick={selectEmo}>🤔</span>
                         <span className="emoimg" em="😑"  v={val} onClick={selectEmo}>😑</span>
                         <span className="emoimg" em="😡"  v={val} onClick={selectEmo}>😡</span>
                         <span className="emoimg" em="👿"  v={val} onClick={selectEmo}>👿</span>
                         <span className="emoimg" em="😵"  v={val} onClick={selectEmo}>😵</span>
                         <span className="emoimg" em="💩"  v={val} onClick={selectEmo}>💩</span>
                         <span className="emoimg" em="👻"  v={val} onClick={selectEmo}>👻</span>
                         <span className="emoimg" em="👽"  v={val} onClick={selectEmo}>👽</span>
                         <span className="emoimg" em="👈"  v={val} onClick={selectEmo}>👈</span>
                         <span className="emoimg" em="👉"  v={val} onClick={selectEmo}>👉</span>
                         <span className="emoimg" em="👆"  v={val} onClick={selectEmo}>👆</span>
                         <span className="emoimg" em="🖕"  v={val} onClick={selectEmo}>🖕</span>
                         <span className="emoimg" em="👇"  v={val} onClick={selectEmo}>👇</span>
                         <span className="emoimg" em="☝️"  v={val} onClick={selectEmo}>☝️</span>
                         <span className="emoimg" em="👏"  v={val} onClick={selectEmo}>👏</span>
                         <span className="emoimg" em="🫶"  v={val} onClick={selectEmo}>🫶</span>
                         <span className="emoimg" em="💪"  v={val} onClick={selectEmo}>💪</span>
                         <span className="emoimg" em="👀"  v={val} onClick={selectEmo}>👀</span>
                    </span>

    if(emo == 'hide') emobxo = null;



    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }


    var defClsStyle = '';
    var varFormated = '';

    if(props.cls != null && props.cls != undefined && val != undefined)
    {
        defClsStyle  =  props.cls; 
        var firstCharacter = val.charAt(0);
        
        if(defClsStyle != 'pwhite' && defClsStyle != '' && firstCharacter != "\n")
        {
            varFormated = "\n\n" + val;
        }else
        {            
            varFormated = val;          
        }
    }


    var firstCharacter = varFormated.charAt(0);
    if(defClsStyle == 'pwhite' && firstCharacter == "\n")
    {
        varFormated = varFormated.substring(2)     ;
    }
 

    var cnX = cn;
    if( val !=null && val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }

    const changeChecked = (e) =>
    {
        var ch = true;
               
        if(checked == false) ch = false;
        
        var v = e.currentTarget.dataset;

        correct = true;    

        if(req == '1' && v.text.length < 1) correct = false;         
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        console.log(v);
        console.log(props);

        setChecked(v.value);
        setVal(v.text);
        

        
        if(props.valChange != null && props.valChange != undefined)
        {   
            

            props.valChange(props.name, v.text, true,'',props.radio, v.value, true,'');
            //props.valChange(props.radio, v.value, ch,'');
                   
        } 
    }    

    if(props.checked != checked)     setChecked(props.checked);

    return <fieldset>
   
            <textarea  ref={inputRef}    value={val } onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX + "  " + defClsStyle}  />       
            <img src={emotion} className="emo" onClick={changeEmo}/>
            {emobxo}
            {imgx}         
            <br/>
            <span className="form_err">{err + " "} &nbsp; </span>          

            <div className="radio_button_box">
            {
                props.items.map( (item, ix) => {

                    if(item.v==props.checked) var checked='checked'; else checked=''

                    return (<div>
                            <div className="radio_button_row" onClick={changeChecked} data-value={item.v} data-text={item.text} data-key={item.v}>
                                <div className={checked+" radio_button_title"}   >{item.title}</div>
                            </div>
                        </div>
                        )
                    } )
            }
            
            <br/>
            <span className="form_err">{err + " "} &nbsp; </span>

            </div>

           </fieldset>
}


export default InputTextAreaRadio;